"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var compile_1 = require("../src/compile");
var compiler = (0, compile_1.default)({
    entry: {
        path: "./lib/tests/static/",
        file: "index.html"
    },
    output: "./lib/tests/output.html"
});
compiler.watch(function (err, stats) {
    console.log("Copmiled");
});
